import { useMemo } from "react";
import { default as KeyValueList } from "../../../../externalComponents/KeyValueList";
import { Text } from "../../../../externalComponents/tailwind/text";
import { formatDateTime } from "../../../../functions/date-utils";

export default function ContactInformationsInformations({
  data,
  onManageConsent,
}) {
  const informations = useMemo(() => {
    const {
      firstName,
      lastName,
      createdAt,
      updatedAt,
      hasOptIn,
      optoutAt,
      optinAt,
      userPhoneNumber,
      bsuid,
      email,
      whatsappName,
      optInSource,
      optoutScenario,
      birthday,
      externalId,
      anonymizedAt,
    } = data || {};
    const formatDate = (label, prop) => {
      if (prop) {
        return { [label]: formatDateTime(prop, "shortTimeLongDate") };
      }
      return {};
    };
    const formatDateOnly = (label, prop) => {
      if (prop) {
        return { [label]: formatDateTime(prop, "mediumDate") };
      }
      return {};
    };
    const formatText = (label, prop) => {
      if (prop) {
        return { [label]: prop };
      }
      return {};
    };

    const consent = hasOptIn ? "optin" : optoutAt ? "optout" : "neverOptin";
    const _data = {
      ...formatText("First name", firstName),
      ...formatText("Last name", lastName),
      ...formatText("Phone number", userPhoneNumber),
      ...formatText("BSUID", bsuid),
      ...formatText("Email", email),
      ...formatText("WhatsApp name", whatsappName),
      ...formatText("External ID", externalId),
      ...formatDateOnly("Birthday", birthday),
      ...formatText("Consent", consent),
      ...formatDate("Created at", createdAt),
      ...formatDate("Updated at", updatedAt),
      ...formatDate("Optin at", optinAt),
      ...formatDate("Optin scenario", optInSource?.name),
      ...formatDate("Optout at", optoutAt),
      ...formatDate("Optout scenario", optoutScenario?.name),
      ...formatDate("Anonymized at", anonymizedAt),
    };
    return _data;
  }, [data]);

  return (
    <>
      <div className="flex items-center justify-between mb-3">
        <Text className="font-bold">Informations</Text>
      </div>

      {Object.keys(informations).length ? (
        <>
          <KeyValueList
            data={informations}
            options={{ Consent: { onClickFunction: onManageConsent } }}
          />
        </>
      ) : (
        "No data found"
      )}
    </>
  );
}
